import { readCart as readCartService } from '@api/graphqlShopify'
import { setCartCookie } from '@helpers/cart'
import { getSelectedCurrency } from '@helpers/currency'
import { getNativeCurrencyCode } from '@helpers/env'
import { setCookie } from '@helpers/session'
import {
  COOKIE_EXPIRE_1_YEAR,
  CURRENCY_SELECTION_ENABLED,
  SELECTED_CURRENCY_COOKIE
} from '@consts/index'
import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { Cart } from 'types/checkout'
import { purgeNullVariantsFromCart } from '../cartHelpers'
import { updateCart, toggleCartNotification, resetCart } from './cartActions'

type ReadCheckoutReturnType = ThunkAction<Promise<void>, void, unknown, Action>

function readCart(cartId: string): ReadCheckoutReturnType {
  return async dispatch => {
    try {
      let cart = (await readCartService(cartId)) as Cart

      if (reconcileSelectedCurrencyWithCart(cart?.cost?.totalAmount?.currencyCode)) {
        window.location.reload()
        return
      }

      const purgedCheckout = await purgeNullVariantsFromCart(cart?.lines)

      if (purgedCheckout) {
        cart = purgedCheckout
        dispatch(toggleCartNotification(true))
      }

      dispatch(updateCart(cart))
    } catch {
      setCartCookie({ expiration: -1 })
      dispatch(resetCart())
    }
  }
}

function reconcileSelectedCurrencyWithCart(cartCurrency: string | undefined): boolean {
  if (!CURRENCY_SELECTION_ENABLED || !cartCurrency) return false

  const effectiveCurrency = getSelectedCurrency() || getNativeCurrencyCode()
  if (cartCurrency.toUpperCase() === effectiveCurrency.toUpperCase()) {
    return false
  }

  setCookie(SELECTED_CURRENCY_COOKIE, cartCurrency, COOKIE_EXPIRE_1_YEAR)
  return true
}

export default readCart
